<template>
  <div style="position: relative;" class="treeview-item">
    <!-- @mouseover="toggleActions($event, true)" @mouseleave="toggleActions($event, false)" -->
    <div class="name root_level" @click.stop="toggle($event)" v-if="model.level == '1'">
      <i class="icon_top_down" style="position: relative;"></i>
      <a :title="model.name" style="position: relative; color: white;" :style="indentStyleh">
        {{model.name}}
        <i :class="{ 'icon_bumen_s': model.type === '1', 'icon_global_w': model.type == '2', 'icon_company_s': model.type == '0' }" style="position: absolute; top: 1px; right: -20px; width: 14px;height: 14px; display: block; margin: 0;"></i>
      </a>
      <!--a v-else :title="model.name" style="position: relative; left: 4px; color: white;">{{model.name}}</a-->
    </div>
    <dt @click.stop="toggle($event, model)" v-else>
      <span v-if="isFolder" :class="[model.opened ? 'icon_b' : 'icon_a']" :style="indentStyle1"></span>
      <a href="javascript:void(0);" :style="indentStyle3" style="position: relative; height: 30px;" :title="model.name">
        <!--span class="folder" v-if="!model.tagInfos"></span>
        <span class="folder" v-if="model.tagInfos && !model.tagInfos[0].style"></span>
        <span v-if="model.tagInfos && model.tagInfos[0].style" style="background: none; width: 18px; height: 18px; margin-top: 3px;">
          <img :src="model.tagInfos[0].style" width="18" height="18" />
        </span-->
        <span :style="getIconOffset2(model.name)">
          <span class="txt" v-html="nodeName" style="top: -4px;"></span>
          <i :style="getIconOffset(model.name)" :class="{ 'icon_bumen_s': model.type === '1', 'icon_global_w': model.type == '2', 'icon_company_s': model.type == '0' }" style="position: absolute; top: 0; margin-top: 4px; width: 14px;height: 14px; display: block;"></i>
        </span>
      </a>
    </dt>
    <div class="actions" :style="indentStyle2" style="position: absolute; height: 100%; text-align: left;">
      <div style="" class="actions-edit" @click.stop="options.edit(model)" v-if="options.editMode">
        <a title="编辑" style="display: block; width: 100%; height:100%;"></a>
      </div>
      <div style="" class="actions-del" @click.stop="options.del(model)" v-if="options.editMode">
        <a title="删除" style="display: block; width: 100%; height:100%;"></a>
      </div>
      <div style="" class="actions-biaoqian" @click.stop="options.addtag(model)" v-if="options.editMode">
        <a title="标签管理" style="display: block; width: 100%; height:100%;"></a>
      </div>
      <input type="checkbox" class="actions-select" :class="[model.selected ? 'focus' : '']" v-model="model.selected" @click.stop="nodeChecked($event, model);options.nodeSelected($event.target.checked, model)" v-if="options.multiselect" />
    </div>
    <div class="hideDiv" style="cursor: pointer;">
      <dl>
        <dd v-show="model.opened" v-if="isFolder">
          <item v-for="item in model.children" :model="item" :options="options" :key="item.id" @node-clicked="nodeClicked" :search-text="searchText"></item>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import utils from './utils'
  import Bus from '@/utils/bus'
  export default {
    name: 'item',
    mounted () {
      if (this.options.selectedNodes) {
        this.iteration(this.options.selectedNodes, this.options.semiCheck, this.model, (val) => { // 设置选中的checkbox
          this.$set(val, 'selected', true) // 样式更新
        })
      }
    },
    watch: {
      'options.selectedNodes' (val) {
        this.iteration(val, this.options.semiCheck, this.model, (val) => { // 设置选中的checkbox
          this.$set(val, 'selected', true) // 样式更新
        })
      }
    },
    computed: {
      isFolder () {
        return this.model.children && this.model.children.length
      },
      indentStyleh () {
        if (this.options.editMode) {
          return { left: '56px' }
        } else {
          if (this.options.multiselect) {
            return { left: '23px' }
          } else {
            return { left: '4px' }
          }
        }
      },
      indentStyle1 () {
        let l = (this.options.editMode) ? 12/1.8 * this.model.level + 2  + 'px': 12/2.2 * this.model.level + 2 + 'px'
        return {
          left: l
        }
      },
      indentStyle2 () {
        var l;
        if (this.model.level == 1) {
          l = 46/2
        } else {
          l = 24/2
        }
        return {
          left: l * this.model.level  + 'px',
          width: (this.options.editMode) ? '54px' : '0'
        }
      },
      indentStyle3 () {
        let l = (this.options.editMode) ? 24/2 * this.model.level + 38 + 'px' :  24/2 * this.model.level + 5 + 'px'
        return {
          left: l
        }
      },
      // 判断当前节点是否存在孩子节点
      isHasChildren () {
        let flag = false;
        if (this.node.children && this.node.children.length > 0) {
          flag = true;
        }
        return flag;
      },

      // 如果当前节点名称，有文字和搜索内容匹配，就把匹配的文字标红。
      // 反之，则正常显示节点名称。
      nodeName () {
        if (this.searchText == undefined || this.searchText == "" || this.searchText == null) {
          return this.model.name;
        }
        if (this.model.name.indexOf(this.searchText) <= -1) {
          return this.model.name;
        }
        return this.replaceAll(this.model.name, this.searchText,
          "<span style='color:#e73936;'>" + this.searchText + "</span>");
      },
      ScrollStyle () {
        if (this.options.hasScroll) {
          return {'margin-right': '24px'}
        }
        return {}
      },
      actionStyle () {
        return { 'left': `${this.menuOffset}px`}
      }
    },
    methods: {
      toggleActions (e, shown) {
        if (shown) {
          if ($(e.currentTarget).hasClass('actions')) {
            $(e.currentTarget).siblings('dt').css({'background': '#ff3633'})
            $(e.currentTarget).siblings('dt').children('a').css('color', 'white')
            $(e.currentTarget).children('.actions-edit').show()
            $(e.currentTarget).children('.actions-del').show()
            $(e.currentTarget).children('.actions-biaoqian').show()
          } else {
            $(e.currentTarget).siblings('.actions').siblings('dt').css({'background': '#ff3633'})
            $(e.currentTarget).siblings('.actions').siblings('dt').children('a').css('color', 'white')
            $(e.currentTarget).siblings('.actions').children('.actions-edit').show()
            $(e.currentTarget).siblings('.actions').children('.actions-del').show()
            $(e.currentTarget).siblings('.actions').children('.actions-biaoqian').show()
          }
        } else {
          if ($(e.currentTarget).hasClass('actions')) {
            $(e.currentTarget).siblings('dt').css('background', 'transparent')
            $(e.currentTarget).siblings('dt').children('a').css('color', 'black')
            $(e.currentTarget).children('.actions-edit').hide()
            $(e.currentTarget).children('.actions-del').hide()
            $(e.currentTarget).children('.actions-biaoqian').hide()
          } else {
            $(e.currentTarget).siblings('.actions').siblings('dt').css('background', 'transparent')
            $(e.currentTarget).siblings('.actions').siblings('dt').children('a').css('color', 'black')
            $(e.currentTarget).siblings('.actions').children('.actions-edit').hide()
            $(e.currentTarget).siblings('.actions').children('.actions-del').hide()
            $(e.currentTarget).siblings('.actions').children('.actions-biaoqian').hide()
          }
        }
      },
      iteration (data, semi, obj, callback) {
        for (var j = 0; j < data.length; j++) {
          if (data[j] && obj) {
            if (data[j].id == obj.id) {
              callback(obj)
            }
            if (semi) {
              if (obj.children != undefined && obj.children.length > 0) {
                this.iteration(obj.children)
              }
            }
          }
        }
      },
      nodeChecked (e, model) {
        var check = e.target.checked
        var itemId = model.id
        if (this.options.semiCheck) {
          if (model.children) { // 点击节点时若有子节点需要也影响子节点的显示
            utils.iteration(model.children, (val) => {
              if (check) {
                this.$set(val, 'selected', true) // 样式更新
              } else {
                this.$set(val, 'selected', false) // 样式更新
              }
            })
          } else {
            if (check) {
              this.$set(model, 'selected', true) // 样式更新
            } else {
              this.$set(model, 'selected', false) // 样式更新
            }
          }
        }
      },
      toggleActive ($stateClass, isF) { // 通过jq class 控制点亮
        if ($stateClass.hasClass('nodeActive')) { // 关闭“高亮”
          $stateClass.removeClass('nodeActive')
        }  else { // 打开“高亮”
          $stateClass.addClass('nodeActive')  // 自己先点亮
          // 影响父级点亮状态
          /* let isSecondLevel2 = $stateClass.parent().parent().parent().siblings().hasClass('root_level')
          if ((!isF) && !isSecondLevel2) { // 是非“二”级的下级菜单
            $stateClass.parent().parent().parent().parent().addClass('nodeActive')
          } */
        }
      },
      toggle ($event, model) { // 菜单折叠
        var $elem = $($event.target)
        var tag = $($event.target)[0].tagName.toLowerCase()
        var isF = Boolean(this.isFolder)
        if (model) { // 点击第一级菜单无“高亮”效果，只做其余级别项的“高亮”效果
          switch (tag) { // 需要处理不同的点击目标
            case 'dt': { // 点击整条item
              $('.treeview-item').removeClass('nodeActive') // 将自己以外的其他项先熄灭
              this.toggleActive($elem.parent('.treeview-item'), isF)
              break
            }
            case 'span': { // 点击到图标或箭头的span上
              $('.treeview-item').removeClass('nodeActive')
              if ($elem.attr('class') == 'icon_a' || $elem.attr('class') == 'icon_b') { // 点到箭头上
                this.toggleActive($elem.parent().parent('.treeview-item'), isF)
              } else { // 点到文件夹图标或文字上，还需要往上选一级parent
                this.toggleActive($elem.parent().parent().parent('.treeview-item'), isF)
              }
              break
            }
          }
        } else {
          $('.treeview-item').removeClass('nodeActive') // 将自己以外的其他项先熄灭
        }
        if (this.options.parentNodeClickable) {
          this.$emit('node-clicked', this.model)
          if (this.isFolder) {
            this.model.opened = !this.model.opened
          }
        } else {
          if (this.isFolder) {
            this.model.opened = !this.model.opened
          } else {
            this.$emit('node-clicked', this.model)
          }
        }
      },
      nodeClicked (node) {
        this.$emit('node-clicked', node)
        if (node && node.children) {
          var w = this.calWidth(node)
          this.$emit('width-resize', w)
        }
      },
      calWidth(node) {
        var max = 0;
        var offset = 32 / 2 * Number(node.level)
        var w;
        function _iteration (data, level) {
          var _getMaxWidth = function (str) {
            return utils.getCurrentStrWidth(str, '12px')
          };
          level++
          for (var j = 0; j < data.length; j++) {
            let maxWidth = _getMaxWidth(data[j].name, '12px')
            if (max < maxWidth) {
              max = maxWidth
            }
            if (data[j].children != undefined && data[j].children.length > 0) {
              _iteration(data[j].children, level)
            }
          }
        }
        _iteration(node.children, node.children.level)
        w = max + offset + 64
        return (w < 240) ? 240 : w
      },
      /**
       * 替换掉原字符串中所有的子字符串。不使用正则表达式的实现。
       * 当遇到特殊字符的时候，不用输入适应正则的转义。
       * @param String str 原字符串
       * @param String substr  要被替换的子串
       * @param String replacement 新的子串
       */
      replaceAll (str, substr, replacement) {
        if (!str) {
          return "";
        }
        return str.split(substr).join(replacement);
      },
      getIconOffset (str) {
        let offset = utils.getCurrentStrWidth(str, '12px')
        return {
          position: 'relative',
          left: offset + 20 + 'px'
        }
      },
      getIconOffset2 (str) {
        if (!this.options.editMode) {
          if (this.options.multiselect) {
            return {}
          } else {
            return {
              left: '-18px',
              top: '2px',
              width: '0'
            }
          }
        } else {
          return {}
        }
      }
    },
    props: ['model', 'options', 'searchText']
  }
</script>
<style scoped>
  @import './index.css';
  .nodeActive { background-color: #eeeeee; }
  .nodeActive a { display: block; }
  .name { cursor: pointer; }

</style>



// WEBPACK FOOTER //
// src/components/common/treeview/item.vue